import script from "./TimeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeTable.vue?vue&type=script&setup=true&lang=ts"

import "./TimeTable.vue?vue&type=style&index=0&id=f46fc7d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46fc7d2"]])

export default __exports__